import React, { useState } from "react";
import { motion } from "framer-motion";
import VirtualTourModal from "../components/VirtualTourModal";

export default function LuxeHeights() {
  const [openTour, setOpenTour] = useState(false);
  const [activeRoom, setActiveRoom] = useState(0);

  const TOUR_ROOMS = [
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOL2F68ON34&locale=en_US",
      thumbnail: "/thumbnails/living-room.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOL2KPEVDQG",
      thumbnail: "/thumbnails/dining-area.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOL2KPC6IH3",
      thumbnail: "/thumbnails/kitchen.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKWPQ6ISJC",
      thumbnail: "/thumbnails/master-bedroom.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKWIRPMYBR",
      thumbnail: "/thumbnails/master-bathroom.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKWIRPMYBR",
      thumbnail: "/thumbnails/master-bathroom.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKWIRK1X45",
      thumbnail: "/thumbnails/guest-bedroom.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKWRV93URJ",
      thumbnail: "/thumbnails/guest-bathroom.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKWRYDGBP8",
      thumbnail: "/thumbnails/study.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKV4CP72H4",
      thumbnail: "/thumbnails/closet.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKV47HJ275",
      thumbnail: "/thumbnails/hallway.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKV46U3H67",
      thumbnail: "/thumbnails/balcony.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKV4A3HIF8",
      thumbnail: "/thumbnails/foyer.jpg",
    },
    {
      label: "Luxe Heights Interior Overview",
      url: "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKV49RATD3",
      thumbnail: "/thumbnails/laundry.jpg",
    },
  ];

  const openVirtualTour = () => {
    setActiveRoom(0);
    setOpenTour(true);
  };

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/luxeheights.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <motion.div
          className="relative z-10 text-center text-white px-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
            Luxe Heights
          </h1>
          <p className="text-lg max-w-2xl mx-auto mb-6">
            An exclusive enclave of luxury residences redefining Aspen’s skyline.
          </p>

          {/* Virtual Tour CTA */}
          <button
            onClick={openVirtualTour}
            className="inline-flex items-center gap-2 bg-white text-black px-7 py-3 rounded-full font-semibold shadow-lg hover:bg-gray-100 transition"
          >
            <span className="text-lg">◉</span>
            <span>360° Virtual Tour</span>
          </button>
        </motion.div>
      </section>

      {/* Overview */}
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12">
        <div>
          <h2 className="text-2xl font-bold mb-4">Overview</h2>
          <p className="text-gray-700 leading-relaxed">
            Luxe Heights is Aspen Plush Homes’ flagship development, designed with unparalleled luxury in mind.
          </p>
          <ul className="mt-6 space-y-2 text-gray-600">
            <li><b>Property Type:</b> Luxury Apartments</li>
            <li><b>Location:</b> Taifa Junction, Accra</li>
            <li><b>Status:</b> Completed</li>
            <li><b>Price:</b> USD 550,000</li>
          </ul>
        </div>

        <div className="bg-gray-100 rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold mb-3">Key Features</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>5 bedrooms fully furnished or unfurnished</li>
            <li>7 washrooms</li>
            <li>2 family areas and 1 living area</li>
            <li>Modern kitchen with premium appliances</li>
            <li>1 maid quarter</li>
            <li>1 balcony</li>
            <li>Walk-in closet</li>
            <li>CCTV surveillance</li>
            <li>State-of-the-art smart home integration</li>
            <li>Spacious penthouse-style apartments</li>
            <li>Swimming pool</li>
            <li>Private parking & concierge services</li>
            <li>Study room / office space</li>
            <li>Energy-efficient design with sustainable materials</li>
            <li>24/7 security and gated access</li>
          </ul>
        </div>
      </div>

      {/* Gallery */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-2xl font-bold mb-6">Gallery</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <img src="/luxe11.jpeg" alt="Luxe Heights 1" className="rounded-lg shadow-md" />
          <img src="/luxe12.jpeg" alt="Luxe Heights 2" className="rounded-lg shadow-md" />
          <img src="/luxe13.jpeg" alt="Luxe Heights 3" className="rounded-lg shadow-md" />
          <img src="/luxe14.jpeg" alt="Luxe Heights 4" className="rounded-lg shadow-md" />
          <img src="/luxe17.jpeg" alt="Luxe Heights 5" className="rounded-lg shadow-md" />
          <img src="/luxe16.jpeg" alt="Luxe Heights 6" className="rounded-lg shadow-md" />
          <img src="/luxe19.jpeg" alt="Luxe Heights 7" className="rounded-lg shadow-md" />
          <img src="/luxe20.jpeg" alt="Luxe Heights 8" className="rounded-lg shadow-md" />
          <img src="/luxe10.jpg" alt="Luxe Heights 9" className="rounded-lg shadow-md" />
        </div>
      </div>

      {/* Contact CTA */}
      <div className="bg-indigo-600 text-white text-center py-12">
        <h2 className="text-3xl font-bold mb-4">Interested in Luxe Heights?</h2>
        <p className="mb-6">Get in touch to experience luxury living at its peak.</p>
        <a
          href="/contact"
          className="bg-white text-indigo-600 px-6 py-3 rounded-lg font-semibold shadow hover:bg-gray-100"
        >
          Contact Us
        </a>
      </div>

      {/* Virtual Tour Modal with Thumbnails */}
      <VirtualTourModal
        open={openTour}
        onClose={() => setOpenTour(false)}
        title="Luxe Heights – Virtual Tour"
        rooms={TOUR_ROOMS}
        activeRoom={activeRoom}
        setActiveRoom={setActiveRoom}
        showThumbnails={true} // horizontal thumbnail strip
      />
    </div>
  );
}
